module.exports = __webpack_public_path__ + "static/media/right-triangle.3dd92a6b.svg";